// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_extraButtonsWrapper__uUAsj {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}
@media screen and (min-width: 992px) {
  .styles_extraButtonsWrapper__uUAsj {
    grid-template-columns: 1fr 1fr;
  }
}
.styles_extraButtonsWrapper__uUAsj a {
  padding: 8px 16px;
  border-radius: 12px;
  font-weight: 600;
  border: 2px solid;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 14px;
  background-color: #fff;
}
.styles_extraButtonsWrapper__uUAsj a.styles_askAI__wbHX\\+ {
  color: #6ba7a8;
  border-color: #6ba7a8;
}
.styles_extraButtonsWrapper__uUAsj a.styles_reportButton__LHpvi {
  color: #bb5240;
  border-color: #bb5240;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/SingleTranscript/ExtraButtons/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,0BAAA;EACA,SAAA;AACF;AAAE;EAJF;IAKI,8BAAA;EAGF;AACF;AADE;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;AAGJ;AADI;EACE,cAAA;EACA,qBAAA;AAGN;AAAI;EACE,cAAA;EACA,qBAAA;AAEN","sourcesContent":[".extraButtonsWrapper {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n  @media screen and (min-width: 992px) {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  a {\n    padding: 8px 16px;\n    border-radius: 12px;\n    font-weight: 600;\n    border: 2px solid;\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    font-size: 14px;\n    background-color: #fff;\n\n    &.askAI {\n      color: #6ba7a8;\n      border-color: #6ba7a8;\n    }\n\n    &.reportButton {\n      color: #bb5240;\n      border-color: #bb5240;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"extraButtonsWrapper": `styles_extraButtonsWrapper__uUAsj`,
	"askAI": `styles_askAI__wbHX+`,
	"reportButton": `styles_reportButton__LHpvi`
};
export default ___CSS_LOADER_EXPORT___;
